import { change as changeFormValue, Field, FormSection, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { useValidation } from '@eti/providers';
import * as allProducts from '../../products';
import MutuallyExclusive from '../components/MutuallyExclusive';
import { generateMuxProductKey, getEmptyOptionId, getPrice, getSelectionPerTravelerId } from '../utils';
import { mutuallyExclusive } from '../index';
import { jsx as _jsx } from "react/jsx-runtime";
const getNewFormValues = (selectedProductId, products) => products.map(product => {
  const field = Object.values(allProducts).find(allProduct => allProduct.id === Number(product.id));
  const fieldName = (field === null || field === void 0 ? void 0 : field.name) || '';
  const {
    sellSpecification
  } = product;
  const value = product.id === selectedProductId;
  const priceRaw = value ? getPrice(sellSpecification) : null;
  const travelerIds = getSelectionPerTravelerId(sellSpecification);
  const formValue = travelerIds ? {
    value: {
      priceRaw,
      value
    },
    travelerIds
  } : {
    value: {
      priceRaw,
      value
    }
  };
  return {
    fieldName,
    formValue
  };
});
const getOnChange = (dispatch, _ref) => {
  let {
    form,
    products
  } = _ref;
  return (_event, selectedProductId) => {
    const newFormValues = getNewFormValues(selectedProductId, products);
    newFormValues === null || newFormValues === void 0 || newFormValues.forEach(_ref2 => {
      let {
        fieldName,
        formValue
      } = _ref2;
      if (!fieldName) {
        return;
      }
      dispatch(changeFormValue(form, fieldName, formValue));
    });
  };
};
const mapStateToProps = (state, _ref3) => {
  var _products$some;
  let {
    form,
    products
  } = _ref3;
  const identifierKey = generateMuxProductKey(products);
  const ancillaryBundleSelectedProducts = formValueSelector(form)(state, 'ancillaryBundle.value.productsInSelection') || [];
  const mutuallyExclusiveCardSelection = formValueSelector(form)(state, `mutuallyExclusive.${identifierKey}`);
  const selectedProductSection = Object.values(allProducts).find(product => String('id' in product ? product.id : 0) === mutuallyExclusiveCardSelection);
  const selectedProductSectionName = selectedProductSection && 'name' in selectedProductSection ? selectedProductSection.name : '';
  const selectedProductState = selectedProductSectionName ? formValueSelector(form)(state, `${selectedProductSectionName}.value.value`) : null;
  const isSelectionValid = mutuallyExclusiveCardSelection === getEmptyOptionId(identifierKey) || mutuallyExclusiveCardSelection && selectedProductState;
  return {
    isAnyProductSelectedInBundle: (_products$some = products === null || products === void 0 ? void 0 : products.some(product => ancillaryBundleSelectedProducts.includes(product === null || product === void 0 ? void 0 : product.id))) !== null && _products$some !== void 0 ? _products$some : false,
    selection: isSelectionValid ? mutuallyExclusiveCardSelection : null
  };
};
const mapDispatchToProps = (dispatch, props) => ({
  onChange: getOnChange(dispatch, props)
});
const MutuallyExclusiveFieldWrapper = _ref4 => {
  let {
    className,
    isAnyProductSelectedInBundle,
    onChange,
    products,
    selection,
    form
  } = _ref4;
  const validate = useValidation(mutuallyExclusive.name);
  const identifierKey = generateMuxProductKey(products);
  return /*#__PURE__*/_jsx(FormSection, {
    name: mutuallyExclusive.name,
    children: /*#__PURE__*/_jsx(Field, {
      className: className,
      component: MutuallyExclusive,
      emptyOptionId: getEmptyOptionId(identifierKey),
      form: form,
      isAnyProductSelectedInBundle: isAnyProductSelectedInBundle,
      name: identifierKey,
      onChange: onChange,
      products: products,
      selection: selection,
      validate: validate
    })
  });
};
export default connect(mapStateToProps, mapDispatchToProps)(MutuallyExclusiveFieldWrapper);
//# sourceMappingURL=MutuallyExclusiveContainer.js.map